import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=436a7e86&scoped=true&"
import script from "./TabTitle.vue?vue&type=script&lang=js&"
export * from "./TabTitle.vue?vue&type=script&lang=js&"
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=436a7e86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a7e86",
  null
  
)

export default component.exports